import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { addOnsCardLoadingConfig } from '../AddOnsLoading/AddOnsLoading.Config';

import {
  tabsLoadingConfig,
  separatorLoadingConfig,
  titlesLoadingConfig,
  shimmerPlaceholderConfig,
} from './AddOnsShopLoading.Config';
import styles from './AddOnsShopLoading.Styles';

function renderTitlesLoading() {
  return (
    <View style={styles.marginLeft}>
      <Shimmer config={titlesLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    </View>
  );
}

function renderTabsLoading() {
  return (
    <View style={styles.marginLeft}>
      <Shimmer config={tabsLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    </View>
  );
}

function renderCard(key, theme) {
  return (
    <View style={styles.cardContainerStyle(theme)} key={key}>
      <Shimmer
        config={addOnsCardLoadingConfig(false)}
        shimmerPlaceholderConfig={shimmerPlaceholderConfig}
      />
    </View>
  );
}

function renderSeparatorLoading(theme) {
  return (
    <Shimmer
      config={separatorLoadingConfig(theme)}
      shimmerPlaceholderConfig={shimmerPlaceholderConfig}
    />
  );
}

const AddOnsShopLoading = () => {
  const theme = useTheme();
  return (
    <View style={styles.containerStyle}>
      {renderTitlesLoading()}
      {renderTabsLoading()}
      <View style={styles.loadingContainerStyle}>
        {renderSeparatorLoading(theme)}
        {_map(Array(5), (_, key) => renderCard(key, theme))}
      </View>
    </View>
  );
};

export default AddOnsShopLoading;
